import pvfs from '@/app/lib/utils/permissions/pvfs'

export type NodeType =
  | 'paragraph'
  | 'text'
  | 'heading'
  | 'list'
  | 'list-item'
  | 'quote'
  | 'b-link'
  | 'media-container'
  | 'media-caption'
  | 'media-credit'
  | 'image'
  | 'body-image-container'
  | 'body-image-caption'
  | 'body-image-credit'
  | 'body-image'
  | 'social-callouts'
  | 'footer'
  | 'header-image'
  | 'divider'
  | 'by-the-numbers-container'
  | 'by-the-numbers-callout'
  | 'by-the-numbers-description'
  | 'quote-box-container'
  | 'quote-box-quote'
  | 'quote-box-attribution'
  | 'quote-box-author-title'
  | 'quote-box-explainer'
  | 'market-snapshot'
  | 'story-callout-container'
  | 'story-callout-placeholder'
  | 'button'
  | 'story-list-placeholder'
  | 'sl-container'
  | 'dynamic-subs-container'
  | 'dynamic-subs-paid'
  | 'dynamic-subs-free'
  | 'video-container'
  | 'video'
  | 'video-caption'
  | 'iterable-snippet'
  | 'podcast'
  | 'ad-tout-position'
  | 'games-tout-container'
  | 'pointed-tout'
  | 'alphadots-tout'

export const NODE_TYPE_TO_PVF = {
  paragraph: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  divider: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  text: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  heading: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  list: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'list-item': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  quote: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'b-link': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'media-container': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'media-caption': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'media-credit': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  image: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'body-image-container': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'body-image-caption': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'body-image-credit': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'body-image': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'social-callouts': {
    edit: pvfs.TEMPLATE_EDIT,
    create: pvfs.TEMPLATE_EDIT,
    delete: pvfs.TEMPLATE_EDIT,
  },
  footer: {
    edit: pvfs.TEMPLATE_EDIT,
    create: pvfs.TEMPLATE_EDIT,
    delete: pvfs.TEMPLATE_EDIT,
  },
  'header-image': {
    edit: pvfs.TEMPLATE_EDIT,
    create: pvfs.TEMPLATE_EDIT,
    delete: pvfs.TEMPLATE_EDIT,
  },
  'by-the-numbers-container': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'by-the-numbers-callout': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'by-the-numbers-description': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'quote-box-container': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'quote-box-quote': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'quote-box-attribution': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'quote-box-author-title': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'quote-box-explainer': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'market-snapshot': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'story-callout-container': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'story-callout-placeholder': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.TEMPLATE_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  button: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'story-list-placeholder': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.TEMPLATE_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'sl-container': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'dynamic-subs-container': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'dynamic-subs-paid': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'dynamic-subs-free': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'video-container': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  video: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'video-caption': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'iterable-snippet': {
    edit: pvfs.TEMPLATE_EDIT,
    create: pvfs.TEMPLATE_EDIT,
    delete: pvfs.TEMPLATE_EDIT,
  },
  podcast: {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'ad-tout-position': {
    edit: pvfs.AD_EDIT,
    create: pvfs.AD_EDIT,
    delete: pvfs.AD_EDIT,
  },
  // Used by the slash menu's single "Games Tout" create option.
  'games-tout-container': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  // The concrete node types returned by getType(); looked up by DeleteBlock/Paste.
  'pointed-tout': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
  'alphadots-tout': {
    edit: pvfs.CAMPAIGN_EDIT,
    create: pvfs.CAMPAIGN_EDIT,
    delete: pvfs.CAMPAIGN_EDIT,
  },
}
